<!--
 * @Description:
 * @Version: 1.0.3
 * @Autor: chen wei
 * @Date: 2020-05-19 13:33:34
 * @LastEditors: chen wei
 * @LastEditTime: 2020-07-22 09:07:56
-->
<template>
<div class="message-box">
  <transition @enter="before" enter-active-class="animated fadeInUp" appear>
    <!-- AI的语音气泡 -->
    <div class="msgs" v-if="readData.type == 'left'">
      <div class="user-box">
        <van-image round width="32px" height="32px" fit="cover" :src="readData.avatar_url ? readData.avatar_url : require('./images/icon-headerjiqiren.png')" />
        <div class="avatar_name" v-if="readData.avatar_name">{{ readData.avatar_name }}</div>
        <div class="read-btn" :class="readData.avatar_name ? 'moreTop':''" v-if="readData.isShowText && !readData.hideListen && readData.url" @click.stop="readFun">
          <van-icon v-show="!readData.isPlaying" :name='require("./images/icon-read.png")' size="18" />
          <van-icon v-show="readData.isPlaying" class="scale" :name='require("./images/icon-reading.gif")' size="18" />
        </div>
      </div>
      <div class="msg-all">
        <div class="msg-content" :class="readData.isPlaying ? 'cur': ''" v-if="readData.isShowText">
          <!-- <TouchRipple :center-ripple="false" /> -->
          <div class="top" v-html="readData.msg"></div>
          <div class="bottom van-hairline--top" v-if="readData.type != 'left'">
            <div class="number">90分</div>
          </div>
        </div>
        <div class="msg-content-no" v-else @click.stop="readFun">
          <div class="time-box">
            <van-icon :name='!readData.isPlaying ? require("./images/icon-listen.png") : require("./images/icon-listen.gif")' size="20" />
            <div class="time">{{getTime(readData.audio_duration)}}</div>
          </div>
          <TouchRipple :center-ripple="false" />
        </div>
        <div class="hasTip" v-if="readData.hasTip">
          <div class="showTipBtn" :class="showTip? 'roll':''" @click="showTipFun">想不出来，再点我哦！</div>
          <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" appear>
            <div v-if="showTip" class="showTip">
              参考提示：{{ readData.hasTip }}
            </div>
          </transition>
        </div>
      </div>
      <div class="reflash">
        <van-icon v-if="!readData.isShowText" @click="readData.isShowText = true" :name='require("./images/icon-fanyi.png")' size="24" />
      </div>
    </div>
    <!-- 用户的录音消息 -->
    <div class="user" :class="readData.isAskLuyin ? 'gray' :''" v-else-if="readData.type == 'right'">
      <div class="reflash" v-if="readData.expressionType == 1 && !readData.url"></div>
      <div class="reflash" v-else>
        <van-icon @click="reluyin" v-if="!readData.isAskLuyin" :name='require("./images/icon-reflash-green.png")' size="24" />
        <van-icon v-else :name='require("./images/icon-reflash.png")' size="24" />
      </div>

      <div class="new-msg-content" v-if="readData.expressionType == 1 && !readData.url">
        <div class="msg-content expression" @click="selectThis" :class="readData.isAskLuyin || readData.isPlaying ?'cur' : ''">
          <!-- <TouchRipple :center-ripple="false" /> -->
          <div class="top" v-if="readData.nowExchangeType == 1" v-html="readData.sysText"></div>
          <div class="top" v-else-if="readData.nowExchangeType == 0" v-html="dealTheString(readData.sysText)"></div>
        </div>
        <div class="hasTip" v-if="readData.hasTip && readData.nowExchangeType == 0">
          <div class="showTipBtn" :class="showTip? 'roll':''" @click="showTipFun">想不出来，再点我哦！</div>
          <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" appear>
            <div v-if="showTip" class="showTip">
              参考提示：{{ readData.hasTip }}
            </div>
          </transition>
        </div>
      </div>
      <!-- 跟读模式 -->
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" appear>
        <div class="new-msg-content" v-if="!readData.expressionType || readData.url ">

          <div class="msg-content-no" @click.stop="readFun">
            <div class="time-box">
              <div class="time">{{getTime(readData.audio_duration)}}</div>
              <van-icon v-if="readData.type != 'left'" :name='!readData.isPlaying ? require("./images/icon-listen.png") : require("./images/icon-listen.gif")' size="20" />
            </div>
            <TouchRipple :center-ripple="false" />
          </div>
          <div class="msg-content" :class="readData.isPlaying ?'cur' : ''" v-if="readData.isVip">
            <!-- <TouchRipple :center-ripple="false" /> -->
            <div class="top" v-html="readData.msg"></div>
            <div class="bottom van-hairline--top anwserBox" v-if="readData.expressionType == 2">
              <div class="left">
                <div class="number">{{ readData.isAnwserRight ? '回答正确':'回答错误' }}</div>
                <van-icon :name=' readData.isAnwserRight ? require("./images/icon-anwserRight.png") : require("./images/icon-anwserBad.png")' size="24" />
              </div>
              <div class="hasTip">
                <div class="showTipBtn" :class="showAnwserTip? 'roll':''" @click="showAnwserTipFun">查看答案</div>
              </div>
              <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" appear>
                <div v-if="showAnwserTip" class="showTip">
                  参考答案：{{ readData.anwserTip }}
                </div>
              </transition>
            </div>
            <div v-else-if="readData.expressionType == 3"></div>
            <div class="bottom van-hairline--top" v-else>
              <div class="number">{{ readData.grade }}分</div>
              <van-icon :name=' readData.grade > 60 ? require("./images/icon-good.png") : require("./images/icon-bad.png")' size="24" />
            </div>
          </div>
        </div>
      </transition>
      <div class="user-box">
        <van-image round width="32px" height="32px" fit="cover" :src=" readData.avatar_url ? readData.avatar_url : require('./images/icon-user.png')" />
        <div class="avatar_name" v-if="readData.avatar_name">{{ readData.avatar_name }}</div>
        <div class="read-btn" :class="readData.avatar_name ? 'moreTop':''" @click.stop="readYuanFun" v-if="readData.expressionType == 1 && (readData.nowExchangeType == 1 || readData.url)">
          <van-icon v-show="!readData.isPlaying" :name='require("./images/icon-read.png") ' size="18" />
          <van-icon v-show="readData.isPlaying" class="scale" :name='require("./images/icon-reading.gif")' size="18" />
        </div>
      </div>
    </div>
    <div class="other" v-else-if="readData.type = 'other'">
      <div class="reflash"></div>
      <div class="msg-content">
        <div class="msg">{{ readData.msg }}</div>
        <van-button round type="info" class="lookMore" @click="lookMore">立即查看</van-button>
      </div>
      <div class="user-box"></div>
    </div>
  </transition>
</div>
</template>

<script>
import {
  jumpWebView,
  getArgs
} from '@/assets/js/common'
export default {
  name: 'message',
  props: {
    readData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      showTip: false,
      showAnwserTip: false
    }
  },
  methods: {
    getTime(time) {
      time = parseInt(time - 0)
      const min = parseInt(time / 60)
      const sec = time % 60
      if (min) {
        return min + '\'' + sec + '\'\''
      } else {
        return sec + '\'\''
      }
    },
    showTipFun() {
      if (this.showTip) {
        return
      }
      this.showTip = true
      setTimeout(() => {
        this.showTip = false
      }, 3000)
    },
    showAnwserTipFun() {
      if (this.showAnwserTip) {
        return
      }
      this.showAnwserTip = true
      setTimeout(() => {
        this.showAnwserTip = false
      }, 3000)
    },
    dealTheString(str) {
      str = str.replace(/{_.*?_}/gi, '____________')
      // const arr = str.split('')
      // let newStr = ''
      // arr.forEach(el => {
      //   if (el == ',' || el == '.' || el == '!') {
      //     newStr += el
      //   } else {
      //     newStr += '__'
      //   }
      // })
      return str
    },
    // 加载动画
    before(el) {
      this.$emit('setScroll', el)
    },
    // 重新听
    readFun() {
      this.$emit('readThisMessage', this.readData)
    },
    // 重新听原声的
    readYuanFun() {
      this.$emit('readThisMessageYuan', this.readData)
    },
    //
    selectThis() {
      this.$emit('selectThis', this.readData)
    },
    reluyin() {
      this.$emit('reluyin', this.readData)
    },
    // 非会员去开通会员
    lookMore() {
      const business_id = getArgs().business_id
      let type = 0
      if (this.readData.expressionType) {
        type = this.readData.expressionType
      }
      jumpWebView.openNewWinWithNavigator(location.href.slice(0, location.href.indexOf('/views/')) + '/views/pages/new/oralTestPrivilege.html?business_id=' + business_id + '&type=' + type)
    }
  }
}
</script>

<style lang="less" scoped>
.message-box {
  width: 100%;
  margin-bottom: 30px;

  .msgs {
    display: flex;

    .user-box {
      width: 32px;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-right: 10px;
      position: relative;

      .read-btn {
        position: absolute;
        top: 32px;
        margin-top: 6px;
        padding: 5px 0;
        width: 100%;
        display: flex;
        justify-content: center;
        border-radius: 4px;

        &:active {
          background: #f5f5f5;
        }

        &.moreTop {
          top: 40px;
        }
      }
    }

    .msg-all {
      flex: 1;
      display: flex;
      flex-direction: column;
    }

    .msg-content {
      position: relative;
      overflow: hidden;
      padding: 8px 15px;
      box-sizing: border-box;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 3px 9px 0px rgba(59, 63, 81, 0.09);
      border-radius: 0px 13px 13px 13px;
      border: 2px solid #fff;

      &.cur {
        border-color: rgba(69, 213, 133, 1);
      }

      .top {
        font-size: 16px;
        font-family: HelveticaNeue-Medium, HelveticaNeue;
        font-weight: bold;
        color: rgba(69, 70, 74, 1);
        line-height: 24px;
        word-break: break-word;
      }

      .bottom {
        margin-top: 6px;
        display: flex;
        align-items: center;
        padding-top: 6px;
        font-size: 12px;
        font-weight: bold;
        color: rgba(69, 70, 74, 1);
        line-height: 16px;

        &::after {
          border-color: rgba(58, 62, 80, 0.4);
        }
      }
    }

    .msg-content-no {
      user-select: none;
      position: relative;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      height: 40px;
      padding: 10px 12px;
      box-sizing: border-box;
      background: rgba(69, 213, 133, 1);
      box-shadow: 0px 3px 9px 0px rgba(59, 63, 81, 0.09);
      border-radius: 0px 13px 13px 13px;

      .time-box {
        display: flex;
        align-items: center;

        .time {
          margin-left: 9px;
          font-size: 16px;
          font-family: 'Helvetica Neue';
          font-weight: bold;
          color: rgba(255, 255, 255, 1);
          line-height: 21px;
        }

        /deep/ .van-icon {
          transform: rotate(180deg);
        }
      }
    }

    .hasTip {
      padding-top: 14px;
      display: flex;
      position: relative;

      .showTipBtn {
        display: flex;
        align-items: center;
        font-size: 12px;
        font-weight: bold;
        color: rgba(116, 118, 125, 1);
        line-height: 16px;

        &::after {
          content: '';
          display: block;
          width: 0;
          height: 0;
          border-left: 5px solid transparent;
          border-right: 5px solid transparent;
          border-top: 6px solid #74767d;
          margin-left: 4px;
        }

        &.roll {
          &::after {
            transform: rotate(180deg);
          }
        }
      }

      .showTip {
        position: absolute;
        top: 36px;
        left: 0;
        z-index: 9;
        border-radius: 10px;
        padding: 10px 18px;
        box-sizing: border-box;
        width: 100%;
        color: #fff;
        font-size: 13px;
        font-weight: bold;
        background: rgba(164, 167, 176, 1);
        box-shadow: 0px 4px 9px 0px rgba(59, 63, 81, 0.09);

        &::after {
          position: absolute;
          top: -5px;
          left: 45px;
          content: '';
          display: block;
          width: 0;
          height: 0;
          border-left: 5px solid transparent;
          border-right: 5px solid transparent;
          border-bottom: 6px solid rgba(164, 167, 176, 1);
        }
      }
    }

    .reflash {
      width: 42px;
      display: flex;
      justify-content: center;
      padding-top: 9px;
    }
  }

  .user {
    display: flex;

    .user-box {
      width: 32px;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-left: 10px;
      position: relative;

      .read-btn {
        position: absolute;
        top: 32px;
        margin-top: 6px;
        padding: 5px 0;
        width: 100%;
        display: flex;
        justify-content: center;
        border-radius: 4px;

        &:active {
          background: #f5f5f5;
        }

        &.moreTop {
          top: 40px;
        }
      }
    }

    .new-msg-content {
      flex: 1;
      display: flex;
      flex-direction: column;
    }

    .msg-content-no {
      user-select: none;
      position: relative;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      height: 40px;
      padding: 10px 12px;
      box-sizing: border-box;
      background: rgba(69, 213, 133, 1);
      box-shadow: 0px 3px 9px 0px rgba(59, 63, 81, 0.09);
      border-radius: 13px 0px 13px 13px;

      .time-box {
        display: flex;
        align-items: center;

        .time {
          margin-right: 9px;
          font-size: 16px;
          font-family: 'Helvetica Neue';
          font-weight: bold;
          color: rgba(255, 255, 255, 1);
          line-height: 21px;
        }
      }
    }

    .msg-content {
      margin-top: 10px;
      position: relative;
      // overflow: hidden;
      padding: 8px 15px;
      box-sizing: border-box;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 3px 9px 0px rgba(59, 63, 81, 0.09),
        0px 3px 9px 0px rgba(59, 63, 81, 0.09);
      border-radius: 13px 13px 13px 13px;
      border: 2px solid #fff;

      &.cur {
        border-color: rgba(69, 213, 133, 1);
      }

      &.expression {
        margin-top: 0;
        border-radius: 13px 0px 13px 13px;
      }

      .top {
        font-size: 16px;
        font-family: HelveticaNeue-Medium, HelveticaNeue;
        font-weight: bold;
        color: rgba(69, 70, 74, 1);
        line-height: 24px;
        word-break: break-word;

        /deep/ .green {
          color: #45d585;
        }

        /deep/ .red {
          color: #ef6b48;
        }
      }

      .bottom {
        margin-top: 6px;
        display: flex;
        align-items: center;
        padding-top: 6px;

        &::after {
          border-color: rgba(58, 62, 80, 0.4);
        }

        .number {
          font-size: 12px;
          font-weight: bold;
          color: rgba(69, 70, 74, 1);
          line-height: 16px;
          margin-right: 4px;
        }
      }
    }

    .hasTip {
      padding-top: 14px;
      display: flex;
      justify-content: flex-end;
      position: relative;

      .showTipBtn {
        display: flex;
        align-items: center;
        font-size: 12px;
        font-weight: bold;
        color: rgba(116, 118, 125, 1);
        line-height: 16px;

        &::after {
          content: '';
          display: block;
          width: 0;
          height: 0;
          border-left: 5px solid transparent;
          border-right: 5px solid transparent;
          border-top: 6px solid #74767d;
          margin-left: 4px;
        }

        &.roll {
          &::after {
            transform: rotate(180deg);
          }
        }
      }

      .showTip {
        position: absolute;
        top: 36px;
        left: 0;
        z-index: 9;
        border-radius: 10px;
        padding: 10px 18px;
        box-sizing: border-box;
        width: 100%;
        color: #fff;
        font-size: 13px;
        font-weight: bold;
        background: rgba(164, 167, 176, 1);
        box-shadow: 0px 4px 9px 0px rgba(59, 63, 81, 0.09);

        &::after {
          position: absolute;
          top: -5px;
          right: 45px;
          content: '';
          display: block;
          width: 0;
          height: 0;
          border-left: 5px solid transparent;
          border-right: 5px solid transparent;
          border-bottom: 6px solid rgba(164, 167, 176, 1);
        }
      }
    }

    .anwserBox {
      justify-content: space-between;
      position: relative;

      .left {
        display: flex;
        align-items: center;
      }

      .hasTip {
        padding-top: 0;
      }

      .showTip {
        position: absolute;
        top: 45px;
        left: -15px;
        z-index: 9;
        border-radius: 10px;
        padding: 10px 18px;
        box-sizing: border-box;
        width: calc(100% + 30px);
        color: #fff;
        font-size: 13px;
        font-weight: bold;
        background: rgba(164, 167, 176, 1);
        box-shadow: 0px 4px 9px 0px rgba(59, 63, 81, 0.09);

        &::after {
          position: absolute;
          top: -5px;
          right: 45px;
          content: '';
          display: block;
          width: 0;
          height: 0;
          border-left: 5px solid transparent;
          border-right: 5px solid transparent;
          border-bottom: 6px solid rgba(164, 167, 176, 1);
        }
      }
    }

    &.gray {
      .msg-content-no {
        background: rgba(225, 227, 229, 1);
      }

      .msg-content {
        background: rgba(225, 227, 229, 1);
        border-color: rgba(225, 227, 229, 1);
      }

      .expression {
        background: #fff;
        border-color: rgba(69, 213, 133, 1);
      }
    }

    .reflash {
      width: 42px;
      display: flex;
      justify-content: center;
      padding-top: 9px;

      /deep/ .van-icon {
        margin-left: -10px;
      }
    }
  }

  .other {
    display: flex;

    .user-box {
      width: 32px;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-left: 10px;
    }

    .msg-content {
      flex: 1;
      position: relative;
      overflow: hidden;
      display: flex;
      align-items: center;
      height: 37px;
      background: rgba(164, 167, 176, 1);
      border-radius: 6px;
      padding: 10px;
      box-sizing: border-box;
      justify-content: space-between;

      .msg {
        font-size: 12px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
      }

      .lookMore {
        padding: 0;
        width: 67px;
        height: 25px;
        line-height: 23px;
        background: #fff;
        border-color: #fff;
        font-size: 12px;
        font-weight: 400;
        color: rgba(116, 118, 125, 1);
      }
    }

    .reflash {
      width: 42px;
      display: flex;
      justify-content: center;
      padding-top: 9px;
    }
  }

  .avatar_name {
    font-size: 10px;
    margin-top: 2px;
    font-weight: 400;
    color: #45464a;
    max-width: 32px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .scale {
    transform: scale(1.63);
  }
}
</style>
